import request from "@/utils/request";

// 高科云泊包月 接口查询
export const SelectCarMothlyInfo = data => {
  return request({
    url: "/venue/MothlyVehicle/SelectCarMothlyInfo",
    method: "POST",
    data
  });
};
// 高科云泊包月  表单提交
export const MothlyApplyPay = data => {
  return request({
    url: "/venue/AccountManager/MothlyApplyPayPull",
    method: "POST",
    data
  });
};

// 包月 - 表单提交 - 无包月信息
export const miniProgram = data => {
  return request({
    url: "/venue/monthly/apply/miniProgram",
    method: "POST",
    data
  });
};
// 包月 - 表单提交 - 包月校验
export const miniPrsonalMonthlyOrderCheck = data => {
  return request({
    url: "/venue/vehicle/order/miniPrsonalMonthlyOrderCheck",
    method: "POST",
    data
  });
};
// 包月 - 表单提交 - 有包月信息
export const addMiniPrsonalMonthlyOrder = data => {
  return request({
    url: "/venue/vehicle/order/addMiniPrsonalMonthlyOrder",
    method: "POST",
    data
  });
};
// 包月 - 支付
export const miniProgramMonthlyOrder = data => {
  return request({
    url: "/venue/vehicle/order/miniProgramMonthlyOrder",
    method: "POST",
    data
  });
};

// 公众号H5 获取包月信息
export const queryMonthlyApplyInfo = data => {
  return request({
    url: "/venue/monthly/apply/queryMonthlyApplyInfo",
    method: "GET",
    params: data
  });
};

// 云端包月 - 表单提交 - 包月校验
export const miniPrsonalMonthlyOrderCheckCloud = data => {
  return request({
    url: "/venueCloud/vehicle/order/miniPrsonalMonthlyOrderCheckCloud",
    method: "POST",
    data
  });
};

// 云端包月 - 支付
export const cloudMiniProgramMonthlyOrder = data => {
  return request({
    url: "/venueCloud/vehicle/order/cloudMiniProgramMonthlyOrder",
    method: "POST",
    data
  });
};
// 云端包月 - 表单提交 - 有包月信息
export const addCloudMiniPrsonalMonthlyOrder = data => {
  return request({
    url: "/venueCloud/vehicle/order/addCloudMiniPrsonalMonthlyOrder",
    method: "POST",
    data
  });
};
// 云端包月 - 表单提交 - 无包月信息
export const miniProgramCloud = data => {
  return request({
    url: "/venueCloud/monthly/apply/miniProgramCloud",
    method: "POST",
    data
  });
};
// 公众号H5 云端获取包月信息
export const queryMonthlyApplyInfoCloud = data => {
  return request({
    url: "/venueCloud/monthly/apply/queryMonthlyApplyInfoCloud",
    method: "GET",
    params: data
  });
};
